import { Dispatch, SetStateAction, useCallback } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'

const useSelectWeekday = (
  update: Dispatch<SetStateAction<DayOfWeekType[]>>,
  setIsEdited?: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(
    (value: DayOfWeekType) => {
      update((prevState) => {
        // 選択済みの値であれば削除
        if (prevState.some((weekday) => weekday === value)) {
          return prevState.filter((weekday) => weekday !== value)
        } else {
          return [...prevState, value]
        }
      })
      setIsEdited && setIsEdited(true)
    },
    [update, setIsEdited]
  )
}

export default useSelectWeekday
